import { types } from '../../types/types';

export const initialState = {
	datesPeritaje: [],
	fullDatesPeritaje: [],
	active: null
}

export const reservaPeritoReducer = (state = initialState, action) => {

	switch (action.type) {

		case types.loadDatesPeritaje:
			return {
				...state,
				datesPeritaje: action.payload

			}

		case types.loadFullDatesPeritaje:
			return {
				...state,
				fullDatesPeritaje: action.payload

			}

		case types.loadActive:
			return {
				...state,
				active: {
					...action.payload
				}
			}

		case types.cleanActive:
			return {
				...state,
				active: null
			}

		case types.cleanDatesPeritaje:
			return initialState

		default:
			return state
	}


}